import { render, staticRenderFns } from "./DepartmentPriceSet.vue?vue&type=template&id=ee23fbee&scoped=true"
import script from "./DepartmentPriceSet.vue?vue&type=script&lang=js"
export * from "./DepartmentPriceSet.vue?vue&type=script&lang=js"
import style0 from "./DepartmentPriceSet.vue?vue&type=style&index=0&id=ee23fbee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee23fbee",
  null
  
)

export default component.exports